import companyIntroService from '@/api/companyIntroService'
const state = {
    // 荣誉奖项列表1
    awardOneImgList: [],
    // 荣誉奖项列表2
    awardTwoImgList: [],
    // 政府合作项目
    goverCoProjects: []
}
const mutations = {
    // 设置荣誉奖项列表1
    SET_AWARDS_ONE_LIST: (state, data) => {
        state.awardOneImgList = data.list || []
    },
    // 设置荣誉奖项列表2
    SET_AWARDS_TWO_LIST: (state, data) => {
        state.awardTwoImgList = data.list || []
    },
    // 设置政府合作项目
    SET_COVER_CO_PROJECTS: (state, data) => {
        state.goverCoProjects = data.list || []
    }
}
const actions = {
    // 获取荣誉奖项列表1
    getAwardsOneList({ commit }, params) {
        return new Promise((resolve, reject) => {
            companyIntroService.fetchAwardsOneList(params)
                .then(res => {
                    resolve(res)
                    const { data } = res
                    commit('SET_AWARDS_ONE_LIST', data)
                })
        })
    },
    // 获取荣誉奖项列表2
    getAwardsTwoList({ commit }, params) {
        return new Promise((resolve, reject) => {
            companyIntroService.fetchAwardsTwoList(params)
                .then(res => {
                    resolve(res)
                    const { data } = res
                    commit('SET_AWARDS_TWO_LIST', data)
                })
        })
    },
    // 获取政府支持重点项目
    getGoverCoProject({ commit }, params) {
        return new Promise((resolve, reject) => {
            companyIntroService.fetchGoverCoProject(params)
                .then(res => {
                    resolve(res)
                    const { data } = res
                    commit('SET_COVER_CO_PROJECTS', data)
                })
        })
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/companyIntro.js